// extracted by mini-css-extract-plugin
export var lg = "_31-4";
export var md = "_31-3";
export var sm = "_31-2";
export var xs = "_31-1";
export var xxs = "_31-0";